/* eslint-disable */
function fetchLocal(url) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest
        xhr.onload = function () {
            resolve(new Response(xhr.responseText));
        }
        xhr.onerror = function () {
            reject(new TypeError('Local request failed'))
        }
        xhr.open('GET', url)
        xhr.send(null)
    })
}

export default {
    LanguageList: [],
    NewLanguageList: [],
    Initialise(langCode) {
        var self = this;
        return new Promise(function (resolve, reject) {
            var languageSelected = true;
            var url;

            if (localStorage.LanguageCode == undefined && langCode == undefined) {
                url = "Languages/en.json?" + new Date();
                languageSelected = false;
            }

            if (langCode != undefined) {
                url = "Languages/" + langCode + ".json?" + new Date();
            } else if (localStorage.LanguageCode != undefined) {
                url = "Languages/" + localStorage.LanguageCode + ".json?" + new Date();
            }

            fetchLocal(url).then(response => response.json()).then(response => {
                self.LanguageList = response;
                if (languageSelected) {
                    resolve();
                } else {
                    resolve("No language found, showing default");
                }
            })
        });
    },
    install(Vue) {
        let self = this;
        // Set Language List
        Vue.prototype.SetLanguageList = (list) => {
            self.LanguageList = list;
        }

        Vue.prototype.TranslateText = (text) => {
            if (self.LanguageList[text] == undefined) {
                var newTextList = [];

                return text + "**";
            } else {
                return self.LanguageList[text];
            }
        }

        // //Generate File from data in $store
        Vue.prototype.ExportFile = () => {
            localStorage.UnassignedText.forEach(element => {
                self.LanguageList[element] = "";
            });

            var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(self.LanguageList));
            var a = document.createElement('a');
            a.href = dataStr;
            a.download = localStorage.LanguageCode + ".json";
            a.id = 'download_language_link'
            document.body.appendChild(a);
            a.click();

            setTimeout(() => {
                var removeanchor = document.getElementById('download_language_link');
                removeanchor.remove();
            }, 5000)
        }
    }
}